<template>
  <div
    id="sidebar-placeholder"
    :class="{ 'hidden': !isSideBarOpenDesktop }"
  ></div>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount, watch } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const isSideBarOpenDesktop = computed(() => store.state.navigation.isSideBarOpenDesktop)

const updateBodyClass = () => {
  if (isSideBarOpenDesktop.value) {
    document.body.classList.remove('sidebar-collapsed')
  } else {
    document.body.classList.add('sidebar-collapsed')
  }
}

watch(isSideBarOpenDesktop, updateBodyClass)

onMounted(() => {
  updateBodyClass()
})

onBeforeUnmount(() => {
  document.body.classList.remove('sidebar-collapsed')
})
</script>

<style scoped>
.hidden {
  display: none !important;
}
</style>
